var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 22",
    alt: "Appontment Calendar Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3,1.7h-3.7V1.2c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v0.6h-3.3V1.2c0-0.3-0.3-0.6-0.6-0.6 c-0.3,0-0.6,0.3-0.6,0.6v0.6H5.7V1.2c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v0.6H0.7C0.4,1.7,0.1,2,0.1,2.3v12.9 c0,0.3,0.3,0.6,0.6,0.6h3.5C4.8,18.2,6.9,20,9.5,20s4.7-1.8,5.3-4.2h3.5c0.3,0,0.6-0.3,0.6-0.6V2.3C18.9,2,18.6,1.7,18.3,1.7 L18.3,1.7z M4.6,2.9v0.5C4.6,3.7,4.9,4,5.2,4s0.6-0.3,0.6-0.6V2.9h3.2v0.5C8.9,3.7,9.2,4,9.5,4c0.3,0,0.6-0.3,0.6-0.6V2.9h3.3v0.5 C13.4,3.7,13.7,4,14,4c0.3,0,0.6-0.3,0.6-0.6V2.9h3.2v2.3H1.3V2.9H4.6z M9.5,18.9c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3 s4.3,1.9,4.3,4.3S11.9,18.9,9.5,18.9z M14.9,14.7C14.9,14.6,14.9,14.6,14.9,14.7c0-3.1-2.4-5.5-5.4-5.5s-5.4,2.4-5.4,5.4 c0,0,0,0.1,0,0.1H1.3V6.4h16.5v8.3H14.9L14.9,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,14.7v-2.8c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6v3c0,0.2,0.1,0.3,0.2,0.4l1.3,1.3 c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8L10.1,14.7L10.1,14.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.1d097254.svg";
export { ForwardRef as ReactComponent };